(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/common"), require("@angular/common/http"), require("rxjs/Rx"), require("@angular/forms"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/common", "@angular/common/http", "rxjs/Rx", "@angular/forms"], factory);
	else if(typeof exports === 'object')
		exports["ng4Geoautocomplete"] = factory(require("@angular/core"), require("@angular/common"), require("@angular/common/http"), require("rxjs/Rx"), require("@angular/forms"));
	else
		root["ng4Geoautocomplete"] = factory(root["ng"]["core"], root["ng"]["common"], root["ng"]["commonHttp"], root["Rx"], root["ng"]["forms"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_10__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition